import { render, staticRenderFns } from "./StarshipSizeDetails.vue?vue&type=template&id=32366b76&lang=pug&"
import script from "./StarshipSizeDetails.vue?vue&type=script&lang=ts&"
export * from "./StarshipSizeDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports